import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Textarea from 'react-textarea-autosize'
import { compose, lifecycle, withHandlers, withState, branch, renderNothing } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'

import { fetchingState } from '../../helpers/hocs.js'
import { getLoggedUser } from '../../selectors/user.js'
import { getComments, getCount, addComment } from '../../store/reducers/comments'

import CommentList from './../../components/Comments/List'

const Comments = ({ items = [], total = 0, user, onChange, addComment, addClickComment, getComments, commentText, fetching, showBtn, setShowBtn, intl }) => (!user && !total) ? null : (
  <div className='Comments'>
    <div className='SubHead Comments__title'>
      <FormattedMessage id='comments_index.comments' />
    </div>

    <CommentList items={items} loading={fetching.list} />

    { (total > items.length) && (<button className='Main__founds-more Text Link Link_single' onClick={getComments.bind(this, items.length)}>
      <FormattedMessage id='comments_index.more' />
    </button>)}

    {(user && !showBtn) && (<button className='Button Button_black' onClick={e => setShowBtn(true)}>
      <FormattedMessage id='comments_index.leave_comment' />
    </button>)}

    {(user && showBtn) && (
      <div action='' className='Comments__form' onKeyPressCapture={addComment}>
        <Textarea className='Comments__field' value={commentText} onChange={onChange.bind(this)} minRows={1} placeholder={intl.formatMessage({id: 'comments_index.write_comment'})} />
        <button type='button' onClick={addComment} className='Comments__submit'>→</button>
      </div>
    )}
  </div>
)

const mapStateToProps = state => ({ user: getLoggedUser(state), ...state.comments })

const mapDispatchToProps = dispatch => bindActionCreators({ getComments, getCount, addComment }, dispatch)

const mergeProps = (state, dispatch, props) => ({
  ...props,
  ...state,
  getComments: (offset = 0) => {
    if (!props.type || !props.entryId) return
    return props.fetchingWrap(dispatch.getComments.bind(this, props.entryId, props.type, { offset, limit: offset ? 10 : 5 }, !offset), 'list')
  },
  getCount: () => {
    if (!props.type || !props.entryId) return
    return dispatch.getCount(props.entryId, props.type)
  },
  addComment: message => {
    if (!props.type || !props.entryId) return
    return props.fetchingWrap(dispatch.addComment.bind(this, props.entryId, message, props.type), 'add')
  }
})

export default injectIntl(compose(
  branch(
    ({ entryId, type }) => !type || ([ 'lots', 'articles' ].indexOf(type) === -1) || !entryId,
    renderNothing
  ),
  fetchingState({ multi: true }),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withState('commentText', 'setCommentText', ''),
  withState('commentErr', 'setCommentErr', null),
  withState('showBtn', 'setShowBtn', null),
  withHandlers({
    onChange: ({ setCommentText }) => e => {
      let value = e.target.value.replace(/(<([^>]+)>)/ig, '')
      setCommentText(value)
    },
    addComment: ({ addComment, fetching, setCommentErr, setCommentText, commentText }) => async e => {
      if (e.key && e.key !== 'Enter') return
      else if (fetching.add) return
      else e.preventDefault()

      let error = null
      if (!commentText || !commentText.length) error = 'no_comment_text'
      setCommentErr(error)
      if (error) return

      let result = await addComment(commentText)
      if (result === 200) setCommentText('')
    }
  }),
  lifecycle({
    componentWillMount () {
      this.props.getComments()
      this.props.getCount()
    }
  })
)(Comments))



// WEBPACK FOOTER //
// ./src/containers/Comments/index.jsx